import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'
import { RadialProgressSeparator } from '../RadialProgressSeparator'

const Container = styled.div`
  .CircularProgressbar {
    width: 100%;
    vertical-align: middle;
  }

  .CircularProgressbar .CircularProgressbar-path {
    stroke: #3e98c7;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.5s ease 0s;
  }

  .CircularProgressbar .CircularProgressbar-trail {
    stroke: #d6d6d6;
    stroke-linecap: round;
  }

  .CircularProgressbar .CircularProgressbar-text {
    fill: #3e98c7;
    font-size: 20px;
    dominant-baseline: middle;
    text-anchor: middle;
  }

  .CircularProgressbar .CircularProgressbar-background {
    fill: #d6d6d6;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-background {
    fill: #3e98c7;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text {
    fill: #fff;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path {
    stroke: #fff;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail {
    stroke: transparent;
  }
`

export const CircularIntegerProgress = ({
  styles,
  steps,
  stepsCompleted,
  strokeWidth,
  children,
}) => {
  const completed = stepsCompleted > steps ? steps : stepsCompleted
  const percentage = Math.round((completed / steps) * 100)
  const hasChildren = !!children
  const text = !hasChildren ? `${percentage}%` : ''

  return (
    <Container>
      <CircularProgressbarWithChildren
        value={percentage}
        text={text}
        strokeWidth={strokeWidth}
        styles={{
          strokeLinecap: 'butt',
          ...styles,
        }}
      >
        {hasChildren && children}
        <RadialProgressSeparator
          count={steps}
          style={{
            background: '#fff',
            width: '3px',
            height: `${strokeWidth + 1}%`,
          }}
        />
      </CircularProgressbarWithChildren>
    </Container>
  )
}

CircularIntegerProgress.propTypes = {
  styles: PropTypes.object,
  steps: PropTypes.number.isRequired,
  stepsCompleted: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number,
  children: PropTypes.element,
}

CircularIntegerProgress.defaultProps = {
  steps: 4,
  stepsCompleted: 2,
  strokeWidth: 1,
}
